/**
* Nom : statistics.js
* Description : Ce fichier contient la définition de la page statistics 
*               Cette page contient les KPIs des données Boxibrain
* Date de création : 7 juillet 2026
*/

/* CSS et assets */
import {AT_logo} from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { TabRD } from "package_ui_ihm/dist"
import { Container } from "package_ui_ihm/dist"
import { ItemKpi } from "package_ui_ihm/dist"
import Divider from '@mui/material/Divider';
import { ListFilter } from "package_ui_ihm/dist"
import { KpiChart } from "package_ui_ihm/dist"
import { KpiBars } from "package_ui_ihm/dist"
import dayjs from 'dayjs';
import 'dayjs/locale/fr'; // <-- importe la locale

/* Hook */
import { useState, useEffect } from 'react';
import { useAuth } from 'package_ui_ihm/dist'
import { useApi } from 'package_ui_ihm/dist'
import { useScreenWidth } from 'package_ui_ihm/dist'


// définit 'fr' comme locale globale
dayjs.locale('fr'); 


/**
* Statistics : affiche la page qui contient les KPIs des données Boxibrain 
*
* Type : page 
*
* Parametres : 
*  None
*/
function Statistics() {

  // Define useState hooks
  const [categoriesNumber, setCategoriesNumber] = useState(0)
  const [varietiesNumber, setVarietiesNumber] = useState(0)
  const [targetTypesNumber, setTargetTypesNumber] = useState(0)
  const [targetsNumber, setTargetsNumber] = useState(0)
  const [treatmentTypesNumber, setTreatmentTypesNumber] = useState(0)
  const [trialsNumber, setTrialsNumber] = useState(0)
  const [modalitiesNumber, setModalitiesNumber] = useState(0)
  const [projectsNumber, setProjectsNumber] = useState(0)
  const [scientificArticlesNumber, setScientificArticlesNumber] = useState(0)
  const [atReportsNumber, setAtReportsNumber] = useState(0)
  const [companiesNumber, setCompaniesNumber] = useState(0)
  const [usersNumber, setUsersNumber] = useState(0)
  const [productsNumber, setProductsNumber] = useState(0)
  const [equipmentsNumber, setEquipmentsNumber] = useState(0)
  const [isDataLoading, setDataLoading] = useState(false)
  const [trials, setTrials] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [graphWidth, setGraphWidth] = useState(0);  
  const [graphHeight, setGraphHeight] = useState(0);
  const [graphMargin, setGraphMargin] = useState({ left: 0 }); 
  const [statisticsTypeList, setStatisticsTypeList] = useState([{'id': 1, 'name': 'R&D'}, {'id': 2, 'name': 'Gestion client'}])
  const [selectedStatisticsType, setSelectedStatisticsType] = useState(0);
  const [categoryList, setCategoryList] = useState([])
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [treatmentTypeList, setTreatmentTypeList] = useState([])
  const [selectedTreatmentType, setSelectedTreatmentType] = useState(0);


  // Define useScreenWidth hooks
  const screenWidth = useScreenWidth();


  // Define useContext hooks
  const { authStatus, authToken } = useAuth();
  const { path } = useApi();


  // Define functions
  async function retrieveData(category_id, treatment_type_id) {
    // Token
    const token = "Bearer " + authToken
    // Statistiques
    var url
    if(Number(category_id) > 0 && Number(treatment_type_id) > 0)
    {
      url = path + "/api/statistics/?category_id=" + category_id + "&treatment_type_id=" + treatment_type_id
    }
    else if(Number(category_id) > 0 && Number(treatment_type_id) === 0)
    {
      url = path + "/api/statistics/?category_id=" + category_id
    }
    else if(Number(category_id) === 0 && Number(treatment_type_id) > 0)
    {
      url = path + "/api/statistics/?treatment_type_id=" + treatment_type_id
    }
    else
    {
      url = path + "/api/statistics/"
    }
    const response = await fetch(url, 
      {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: {
            accept: 'application/json',
            Authorization: token,
        },
      }
    );
    const data = await response.json();
    setCategoriesNumber(data["nb_categories"])
    setVarietiesNumber(data["nb_varieties"])
    setTargetTypesNumber(data["nb_target_types"])
    setTargetsNumber(data["nb_targets"])
    setTreatmentTypesNumber(data["nb_treatment_types"])
    setTrialsNumber(data["nb_trials"])
    setModalitiesNumber(data["nb_modalities"])
    setProjectsNumber(data["nb_projects"])
    setScientificArticlesNumber(data["nb_scientific_articles"])
    setAtReportsNumber(data["nb_at_reports"])
    setCompaniesNumber(data["nb_companies"])
    setUsersNumber(data["nb_users"])
    setProductsNumber(data["nb_products"])
    setEquipmentsNumber(data["nb_equipments"])
    // Equipments
    setEquipments(data["equipments"])
    // Trials
    setTrials(data["trials"])
    // Categories
    setCategoryList(data["categories"])
    // Treatment Type
    setTreatmentTypeList(data["treatment_types"])
    // Dataloading
    setDataLoading(false)
  }

  function graphEquipmentRepartition() {
    var nbBoxitunnel = 0;
    var nbBoxilab = 0;
    var nbBoxistick = 0;
    var nbBoxirover = 0;
    equipments.forEach(equipment => 
    {
      if(equipment.product['name'] === 'Boxitunnel')
      {
        nbBoxitunnel = nbBoxitunnel + 1;
      }
      else if(equipment.product['name'] === 'BoxiLab')
      {
        nbBoxilab = nbBoxilab + 1;
      }
      else if(equipment.product['name'] === 'Boxistick')
      {
        nbBoxistick = nbBoxistick + 1;
      }
      else
      {
        nbBoxirover = nbBoxirover + 1;
      }
    })
    var data_graph = [
      { id: 0, value: nbBoxitunnel, label: 'Boxitunnel' },
      { id: 1, value: nbBoxilab, label: 'Boxilab' },
      { id: 2, value: nbBoxistick, label: 'Boxistick' },
      { id: 3, value: nbBoxirover, label: 'Boxirover' },
    ];
    return data_graph;
  }

  function trialStatusRepartition() {
    var nbValidTrials = 0;
    var nbStrongTrials = 0;
    var nbLessTrials = 0;
    var nbFailedTrials = 0;
    trials.forEach(trial => 
    {
      if(trial.validation_status['color'] === 'green')
      {
        nbValidTrials = nbValidTrials + 1;
      }
      else if(trial.validation_status['color'] === 'yellow')
      {
        nbStrongTrials = nbStrongTrials + 1;
      }
      else if(trial.validation_status['color'] === 'orange')
      {
        nbLessTrials = nbLessTrials + 1;
      }
      else
      {
        nbFailedTrials = nbFailedTrials + 1;
      }
    })
    var data_graph = [
      { id: 0, value: nbValidTrials, label: 'Validé', color: 'green' },
      { id: 1, value: nbStrongTrials, label: 'Tendance forte', color: 'yellow' },
      { id: 2, value: nbLessTrials, label: 'Tendance légère', color: 'orange' },
      { id: 3, value: nbFailedTrials, label: 'Echec', color: 'red' },
    ];
    return data_graph;
  }

  function trialYearRepartition() {
    var data_trials = {}
    trials.forEach(trial => {
      const year = trial.year;
      data_trials[year] = (data_trials[year] || 0) + 1;
  });
    var data_graph = []
    Object.keys(data_trials).forEach(year =>
    {
      data_graph.push({'year': year, 'value': data_trials[year]})
    })
    return data_graph;
  }

  function updateGraphSize() {
    var width = (((screenWidth * 0.8) -40) / 2 ) - 40
    if(screenWidth > 1000)
    {
      setGraphWidth(width - 100)
      setGraphHeight(200)
    }
    else if(screenWidth > 650)
    {
      setGraphWidth(width - 75)
      setGraphHeight(150)
    }
    else
    {
      setGraphWidth(width - 65)
      setGraphHeight(130)
    }
  }

  const handleFiles = (event) => {
    event.preventDefault();
    generateFile();
  };
  
  async function generateFile() {
    // Chargement du logo
    var desiredHeight
    var desiredWidt 
    const imageLogo = await new Promise((resolve) => {
        const img = new Image();
        img.src = AT_logo;
        img.onload = () => {
            const canvasLogo = document.createElement('canvas');
            canvasLogo.width = img.width;
            canvasLogo.height = img.height;
            desiredHeight = 15;
            desiredWidt = 15 * img.width / img.height;
            const ctx = canvasLogo.getContext('2d');
            ctx.drawImage(img, 0, 0);
            resolve(canvasLogo.toDataURL('image/png'));
        };
    });
    // Capture du conteneur KPI
    const element = document.getElementById('pdf-statistics'); 
    if (!element) {
      console.error("L'élément n'a pas été trouvé.");
      return;
    }
    const canvas = await html2canvas(element, {
      scale: 0.55, // Réduit la résolution (1 = 100%, 2 = 200%, etc.)
      logging: false,
      useCORS: true,
      allowTaint: true,
    });
    // Création du PDF
    const pdf = new jsPDF({
      orientation: 'portrait', // Passe en mode paysage si nécessaire
      unit: 'mm',
      format: 'a4', // Format A4 (210x297 mm)
    });
    // Ajout du Logo Asclepios Tach
    pdf.addImage(imageLogo, 'PNG', 15, 8, desiredWidt, desiredHeight);
    // Ajout de la date de génération du PDF
    pdf.setFont('Calibri'); 
    pdf.setFontSize(10); // Taille 10
    pdf.setTextColor('#000000'); 
    pdf.text('Date : ' + dayjs().format('DD/MM/YYYY'), 160, 15)
    // Ajout du titre
    pdf.setFont('Calibri', 'bold'); 
    pdf.setFontSize(20); // Taille 12
    pdf.setTextColor('#548235'); 
    pdf.text('Statistiques Boxibrain', 15, 35)
    // Ajout de l'image au PDF
    pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 15, 40);
    pdf.save('Boxibrain_statistiques.pdf');
  }


  // Define useEffect hooks
  useEffect(() => {
    if(authStatus === 200)
    {
      updateGraphSize()
      setDataLoading(true)
      retrieveData(selectedCategory, selectedTreatmentType)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    retrieveData(selectedCategory, selectedTreatmentType)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory, selectedTreatmentType])
  
  useEffect(() => {
    updateGraphSize()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenWidth])


  // Render component
  return (
    <div>
      <TabRD tabNumber={4}/>
      <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
        <Container>
          {isDataLoading ? (
            <p>Chargement des données</p>
          ) : (
            <div id="pdf-statistics">
              {/*Titre*/}
              <h1>Statistiques</h1>
              {/*Filtrage et export PDF*/}
              <div className={(screenWidth > 1000) ? 'grid-1-1 justify-center' : null}>
                {(Number(selectedStatisticsType) === 1) ? (
                  (screenWidth > 600) ? (
                    <div className={'grid-1-2-2-2 justify-center'}>
                      <p>Filtres : </p>                  
                      <ListFilter labelText="Type de statistiques" choices={statisticsTypeList} choiceParam={'name'} selectedItem={selectedStatisticsType} setSelectedItem={setSelectedStatisticsType} subfilter={false}/>
                      <ListFilter labelText="Catégorie" choices={categoryList.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedCategory} setSelectedItem={setSelectedCategory} subfilter={false}/>
                      <ListFilter labelText="Type de traitement" choices={treatmentTypeList} choiceParam={'name'} selectedItem={selectedTreatmentType} setSelectedItem={setSelectedTreatmentType} subfilter={false}/>
                    </div>
                  ) : (
                    <div>
                      <p>Filtres : </p>
                      <div className={(screenWidth > 400) ? 'grid-1-1 justify-center' : null}>
                        <ListFilter labelText="Type de statistiques" choices={statisticsTypeList} choiceParam={'name'} selectedItem={selectedStatisticsType} setSelectedItem={setSelectedStatisticsType} subfilter={false}/>
                        <ListFilter labelText="Catégorie" choices={categoryList.sort((a, b) => (a.name > b.name)?1:-1)} choiceParam={'name'} selectedItem={selectedCategory} setSelectedItem={setSelectedCategory} subfilter={false}/>
                        <ListFilter labelText="Type de traitement" choices={treatmentTypeList} choiceParam={'name'} selectedItem={selectedTreatmentType} setSelectedItem={setSelectedTreatmentType} subfilter={false}/>
                      </div>
                    </div>
                  )
                ) : (
                  <div className={(screenWidth > 600) ? 'grid-1-2-2-2 justify-center' : 'grid-1-2 justify-center'}>
                    <p>Filtres : </p>
                    <ListFilter labelText="Type de statistiques" choices={statisticsTypeList} choiceParam={'name'} selectedItem={selectedStatisticsType} setSelectedItem={setSelectedStatisticsType} subfilter={false}/>
                  </div>
                )}
                <div className={(screenWidth > 1000) ? 'flex-row justify-end' : 'flex-row justify-start'}>
                  <div onClick={handleFiles} className='sublink link-border clickable'>
                    <div className='link-text'>Exporter en PDF</div>
                  </div>
                </div>
              </div>
              {(Number(selectedStatisticsType) <= 1) ? (
                <div>
                  {/*KPI R&D*/}
                  <h3 className='table-cell-ss table-label'>R&D</h3>
                  <div className={(screenWidth > 650) ? 'grid-1-1-1-1' : null}>
                    <ItemKpi title={"Catégories"}>{categoriesNumber}</ItemKpi>
                    <ItemKpi title={"Variétés"}>{varietiesNumber}</ItemKpi>
                    <ItemKpi title={"Types de cible"}>{targetTypesNumber}</ItemKpi>
                    <ItemKpi title={"Cibles"}>{targetsNumber}</ItemKpi>
                  </div>
                  <div className={(screenWidth > 650) ? 'grid-1-1-1' : null}>
                    <ItemKpi title={"Type de traitement"}>{treatmentTypesNumber}</ItemKpi>
                    <ItemKpi title={"Essais"}>{trialsNumber}</ItemKpi>
                    <ItemKpi title={"Modalités d'essais"}>{modalitiesNumber}</ItemKpi>
                  </div>
                  <div className={(screenWidth > 650) ? 'grid-1-1' : null}>
                    <ItemKpi title={"Status des essais"}>
                      <KpiChart 
                        chartData={trialStatusRepartition()} 
                        colorLabel={'black'} 
                        graphWidth={graphWidth} 
                        graphHeight={graphHeight} 
                        graphMargin={graphMargin} 
                      />
                    </ItemKpi>
                    <ItemKpi title={"Nombre d'essais par an"}>
                      <KpiBars 
                        dataset={trialYearRepartition()} 
                        colorLabel={'black'} 
                        graphWidth={graphWidth} 
                        graphHeight={graphHeight} 
                        graphMargin={graphMargin} 
                      />
                    </ItemKpi>
                  </div>
                  <div className={(screenWidth > 650) ? 'grid-1-1-1' : null}>
                    <ItemKpi title={"Projets"}>{projectsNumber}</ItemKpi>
                    <ItemKpi title={"Articles scientifiques"}>{scientificArticlesNumber}</ItemKpi>
                    <ItemKpi title={"Rapports internes"}>{atReportsNumber}</ItemKpi>
                  </div>
                </div>
              ) : (
                null
              )}
              {(Number(selectedStatisticsType) === 0) ? (
                <Divider className="margin-bottom, margin-top"/>
              ) : (
                null
              )}
              {(Number(selectedStatisticsType) !== 1) ? (
                <div>
                  {/*KPI clients*/}
                  <h3 className='table-cell-ss table-label'>Gestion clients</h3>
                  <div className={(screenWidth > 650) ? 'grid-1-1' : null}>
                    <ItemKpi title={"Clients"}>{companiesNumber}</ItemKpi>
                    <ItemKpi title={"Utilisateurs"}>{usersNumber}</ItemKpi>
                  </div>
                  <div className={(screenWidth > 650) ? 'grid-1-1' : null}>
                    <div>
                      <ItemKpi title={"Produits"}>{productsNumber}</ItemKpi>
                      <ItemKpi title={"Produits client"}>{equipmentsNumber}</ItemKpi>
                    </div>
                    <ItemKpi title={"Produits clients / produits"}>
                      <KpiChart 
                        chartData={graphEquipmentRepartition()} 
                        colorLabel={'white'} 
                        graphWidth={graphWidth} 
                        graphHeight={graphHeight} 
                        graphMargin={graphMargin} 
                      />
                    </ItemKpi>
                  </div>
                </div>
              ) : (
                null
              )}
            </div>
          )}
        </Container>
      </div>
    </div>
  );
}

export default Statistics;
